/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ORMObject} from "../core/datamodel";

interface DrawerState {
    stack: string[],
    person: ORMObject[],
    customer: ORMObject[],
    device: ORMObject[],
    devicemodel: ORMObject[],
    user: ORMObject[],
    event: ORMObject[],
    exam: ORMObject[],
    upload: string[],
    todo: ORMObject[],
}

const initialDrawerState: DrawerState = {
    stack: [],
    person: [],
    customer: [],
    device: [],
    devicemodel: [],
    user: [],
    upload: [],
    event: [],
    exam: [],
    todo: [],

}

interface DrawerPayload {
    key: 'person' | 'customer' | 'device' | 'devicemodel' | 'user' | 'password' | 'event' | 'exam' | 'todo' ,
    object: ORMObject,
}

const drawerSlice = createSlice({
    name: 'drawer',
    initialState: initialDrawerState,
    reducers: {
        openDrawer: (state: DrawerState, payload: PayloadAction<DrawerPayload>) => {
            let {key, object} = payload.payload
            switch (key) {
                case 'person':
                    state.person.push(object);
                    state.stack.push('person');
                    break
                case 'customer':
                    state.customer.push(object);
                    state.stack.push('customer');
                    break
                case 'device':
                    state.device.push(object);
                    state.stack.push('device');
                    break
                case 'devicemodel':
                    state.devicemodel.push(object);
                    state.stack.push('devicemodel');
                    break
                case 'user':
                    state.user.push(object);
                    state.stack.push('user');
                    break
                case "password":
                    state.stack.push('password');
                    break
                case "event":
                    state.event.push(object);
                    state.stack.push('event');
                    break
                case "exam":
                    state.exam.push(object);
                    state.stack.push('exam');
                    break
                case "todo":
                    state.todo.push(object);
                    state.stack.push('todo');
                    break
                default:
                    break
            }
        },
        openUpload: (state: DrawerState, payload: PayloadAction<string>) => {
            state.upload.push(payload.payload);
        },
        closeDrawer: (
            state,
            key: PayloadAction<'person' | 'customer' | 'device' | 'devicemodel' | 'user' | 'password' | 'upload' | 'event' | 'exam' | 'todo' >
        ) => {
            switch (key.payload) {
                case 'person':
                    state.person.pop();
                    state.stack.pop();
                    break
                case 'customer':
                    state.customer.pop();
                    state.stack.pop();
                    break
                case 'device':
                    state.device.pop();
                    state.stack.pop();
                    break
                case 'devicemodel':
                    state.devicemodel.pop();
                    state.stack.pop();
                    break
                case 'user':
                    state.user.pop();
                    state.stack.pop();
                    break
                case "password":
                    state.stack.pop();
                    break
                case 'upload':
                    state.upload.pop();
                    break
                case "event":
                    state.event.pop();
                    state.stack.pop();
                    break
                case "exam":
                    state.exam.pop();
                    state.stack.pop();
                    break
                case "todo":
                    state.todo.pop();
                    state.stack.pop();
                    break
                default:
                    break
            }
        },
    }
})

export const {openDrawer, openUpload, closeDrawer} = drawerSlice.actions
export const drawerReducer = drawerSlice.reducer
